<div>
  <input type="file" (change)="onFileSelected($event)" multiple #fileInput style="display: none;">
  <div class="file-upload-options">
    <div style="display: flex; align-items: center">
      <button class="btn btn-primary btn-assessor" (click)="fileInput.click()">
        {{ 'FileUploadComponent.BrowseFiles' | translate }}
      </button>
    </div>
    <div style="display: flex; align-items: center">
      <h6 style="color: dimgray; margin-bottom: 0">OR</h6>
    </div>
    <div class="drag-and-drop-area" [class.highlight-border]="isDraggedOver" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
      style="display: flex; align-items: center; flex-direction: column; ">
      <h5 style="color: #666666;">{{ 'FileUploadComponent.DragAndDropFiles' | translate }}</h5>
      <p style="color: #666666; text-align: center">{{ 'FileUploadComponent.UploadInfo' | translate }}</p>
    </div>
  </div>
  <!--  <hr>-->
  <div style="margin-top: 10px">
    <h2 style="color: black;">{{ 'FileUploadComponent.FileUploads' | translate }}</h2>
    <p style="color: black"><b>{{fileControl.element.files.length}}</b> of {{ fileControl.element.maxFiles }} files uploaded (using <b>{{ fileControl.element.totalFileSize | fileSize }}</b> of {{ fileControl.element.maxTotalSize | fileSize }} available). Allowed extensions: {{ fileControl.element.allowedExtensions | commaSeparated }}.</p>
    <div [hidden]="fileControl.element.files.length === 0">
      @for (file of fileControl.element.files; track file; let i = $index) {
        <div class="file-item" [style.background-color]="i % 2 == 0 ? 'GhostWhite' : 'white'" style="border: 2px dotted #ccc; padding: 10px">
          <p style="margin-bottom: 0">{{ file.name }} (<b>{{ file.size | fileSize }}</b>)</p>
          <button class="btn btn-danger" (click)="deleteFile(file)">Delete</button>
        </div>
      }
    </div>
  </div>
  <ul style="padding-left: 15px">
    @for (error of fileControl.element.fileErrors; track error) {
      <li style="color: red">
        {{ error }}
      </li>
    }
  </ul>
</div>
